import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography';

import { withStyles } from "@material-ui/core/styles";

const style = {
    content: {
        color: 'white',
        margin: 0,
        padding: 0
    },
    footer: {
        backgroundColor: "transparent"
    },
};

const Footer = (props) => {
    const { classes } = props;
    return (
        <Paper className={classes.footer} elevation={0}>
            <Grid container>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Typography variant="subheading" style={style.content}>2022 BCIC</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Typography variant="subheading" style={style.content}>Privacy Statement</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Typography variant="subheading" style={style.content}>Terms of Use</Typography>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default withStyles(style)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js